interface Props {
  coverage: { hours_expected: number; hours_present: number };
}

/**
 * checks_hourly has no backfill for hours missed while the process was down,
 * so a report can silently rest on less data than the range implies. Saying
 * so is the difference between a gap and a wrong number.
 */
export function CoverageNote({ coverage }: Props) {
  const { hours_expected, hours_present } = coverage;
  if (hours_present >= hours_expected) return null;
  return (
    <p className="text-xs text-gray-500 dark:text-gray-400">
      Computed from {hours_present.toLocaleString()} of {hours_expected.toLocaleString()} hours —
      the rest have no recorded data.
    </p>
  );
}
